import * as Yup from 'yup';

export const filterFormSchema = Yup.object().shape({
    ask_amount_gt: Yup.number().typeError('Please enter a valid number').nullable(true),
    ask_amount_lt: Yup.number().nullable(true),
});